import { h } from 'preact'; /** @jsx h */

import AOS from 'aos';
import 'aos/dist/aos.css';
import 'intersection-observer';

import { useEffect } from 'preact/hooks';
import './Quote.scss';

const Quote = ({ children, color = 'secondary', animation }) => {
    // useEffect for AOS
    useEffect(() => {
        AOS.init({
            offset: 30,
            delay: 0
        });
    }, []);

    return (
        <p data-aos={animation} className={`quote color-${color}`}>
            {children}
        </p>
    );
};

export default Quote;
